// src/components/BusinessModels.tsx

import {
  Handshake,
  Building2,
  Dumbbell
} from "lucide-react";

import { motion } from "framer-motion";

import "../styles/businessmodels.css";

const models = [

  {
    icon:<Handshake size={34} />,

    title:"Commission-Based Partnership",

    popular:true,

    desc:
    "We install and maintain the protein shake machine completely free of charge. Your gym earns commission from every shake sold.",

    points:[
      "Zero upfront investment",
      "Passive income stream",
      "Inventory fully managed",
      "Low risk partnership"
    ]
  },


  {
    icon:<Dumbbell size={34} />,

    title:"Exclusive Gym Partnership",

    desc:
    "Provide floor space and basic electricity while your members receive exclusive discounted shakes.",

    points:[
      "Exclusive member discounts",
      "Brand exposure",
      // "Approx €40/month electricity",
      "Joint marketing campaigns"
    ]
  },
  {
  icon:<Building2 size={34} />,

  title:"Corporate Wellness Plan",

  desc:
  "Offer employees “free” or discounted shakes as part of your wellness benefits. The company pays monthly based on actual shake usage, turning better nutrition into an easy, predictable perk",

  points:[
    "Employee wellness benefit",
    "No cafe or Kitchen hassle",
    "Perfect for offices & corporates"
  ]
},

  

];

const BusinessModels = () => {

  return (

    <section
      id="partnership"
      className="business-models"
    >

      {/* =========================
          HEADER
      ========================= */}

      <div className="business-header">

        <span>
          BUSINESS MODELS
        </span>

        <h2>
          Flexible Partnership
          Options For Gyms
          & Corporates
        </h2>

        <p>
          Choose the model that best fits
          your business, members and
          wellness strategy.
        </p>

      </div>

      {/* =========================
          GRID
      ========================= */}

      <div className="models-grid">

        {
          models.map((model,index)=>(

            <motion.div
              key={index}
              className="model-card"
              initial={{ opacity:0, y:40 }}
              whileInView={{ opacity:1, y:0 }}
              transition={{ duration:0.6 }}
              viewport={{ once:true }}
            >

              {/* =========================
                  TOP ROW
              ========================= */}

              <div className="model-top">

                <div className="model-icon">

                  {model.icon}

                </div>

                {
                  model.popular && (

                    <div className="popular-badge">

                      ★ Most Popular

                    </div>

                  )
                }

              </div>

              {/* TITLE */}

              <h3>
                {model.title}
              </h3>

              {/* DESCRIPTION */}

              <p>
                {model.desc}
              </p>

              {/* POINTS */}

              <ul>

                {
                  model.points.map((point,i)=>(

                    <li key={i}>

                      {point}

                    </li>

                  ))
                }

              </ul>

            </motion.div>

          ))
        }

      </div>

    </section>
  );
};

export default BusinessModels;